/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Download
 */
export interface Download {
  /**
   *
   */
  readonly getUrl?: string;
  /**
   *
   */
  isInternal?: boolean;
  /**
   * Optional eTag (md5sum)
   */
  readonly etag?: string | null;
  /**
   * Filesize in bytes
   */
  readonly size?: number | null;
}

/**
 * Check if a given object implements the Download interface.
 */
export function instanceOfDownload(value: object): value is Download {
  return true;
}

export function DownloadFromJSON(json: any): Download {
  return DownloadFromJSONTyped(json, false);
}

export function DownloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Download {
  if (json == null) {
    return json;
  }
  return {
    getUrl: json["get_url"] == null ? undefined : json["get_url"],
    isInternal: json["is_internal"] == null ? undefined : json["is_internal"],
    etag: json["etag"] === undefined ? undefined : json["etag"] === null ? null : json["etag"],
    size: json["size"] === undefined ? undefined : json["size"] === null ? null : json["size"],
  };
}

export function DownloadToJSON(json: any): Download {
  return DownloadToJSONTyped(json, false);
}

export function DownloadToJSONTyped(
  value?: Omit<Download, "getUrl" | "etag" | "size"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    is_internal: value["isInternal"],
  };
}
